<template lang="pug">
.pa-2
  v-dialog(v-model='isDialogEmail'  fullscreen)
    v-card.position-relative(width="550" height="800")
      v-card(:loading="isLoadingHTML" v-if="!isLoadingHTML" v-html="bodyHTML"  width="100%"  height="100%")
      .return
        v-btn.ma-1(color='primary' dark='' fab='' @click="closeDialog()")
          v-icon arrow_back
  v-card.mx-auto.elevation-1
    .d-flex(:class="{'fd-column' : isMovil}")
      .flex-1
        v-card-title.pa-3.pl-4
          span.font-weight-700(:class="{'font-size-17' : isMovil}") Notificaciones email
        v-card-subtitle.pb-3.font-size-13 Listado general de notificaciones por email
      v-divider(v-if="isMovil")
      v-card.d-flex.elevation-0.ai-center(:class="{'ma-2' : !isMovil}")
        v-select.ma-1(v-model='type' :items='types' item-text="label"  item-value="value" dense='' @change="getFetch()"   solo hide-details='' label='Visualizar por')
        v-btn.ma-1( color="primary" small fab='' @click="getFetch()")
          v-icon sync
    .box-table(
      v-infinite-scroll='fetchByScroll',
      infinite-scroll-disabled='disabledScrollExcecute',
      infinite-scroll-distance='2'
    )
      v-data-table.overflow-y-auto(
        :headers='headerTable'
        dense
        fixed-header
        :items='lista'
        :disable-pagination="true"
        hide-default-footer,
        show-expand,
        single-expand
      )
        template(v-slot:item.id="{ item }")
          span.font-weight-700.font-size-10 {{item.id}}
        template(v-slot:item.fechaRegistro="{ item }")
          span.font-weight-700.font-size-10 {{item.fechaRegistro | formatoFecha}}
        template(v-slot:item.fechaEnvio="{ item }")
          v-chip(color="background")
            span.font-weight-700.font-size-10.success--text(v-if="item.enviado") {{item.fechaEnvio | formatoFecha}}
            span.font-weight-700.font-size-10.warning--text(v-else) Todavia no se envia
        template(v-slot:item.enviado="{ item }")
          v-icon(v-if="item.enviado" color="success") check_circle
          v-icon(v-else color="warning") watch_later
        template(v-slot:item.asunto="{ item }")
          span.font-weight-700.font-size-11 {{item.asunto}}
        template(v-slot:item.usuario="{ item }")
          span.font-weight-700.font-size-11 {{item.usuario}}
        template(v-slot:item.conCopiaOculta="{ item }")
          span.font-weight-700.font-size-11 {{item.conCopiaOculta}}
        template(v-slot:item.plantilla="{ item }")
          span.font-weight-700.font-size-11 {{item.plantilla}}
        template(v-slot:expanded-item='{ headers, item }')
          .pa-4
            span.font-weight-700.font-size-11 {{ item.destinatarios }}

        template(v-slot:item.actions="{ item, index }")
          .d-flex
            .d-flex.ai-center(:class="{'ma-1' : !isMovil}")
              v-btn.mr-2( x-small color="info" @click="openDialog(item.id)")
                v-icon.mr-1(size="15") info
                | plantilla
            //- .d-flex.ai-center(:class="{'ma-1' : !isMovil}")
            //-   v-btn.mr-2( x-small color="success" @click="goTo('/ticket/' + item.numero)")
            //-     v-icon.mr-1(size="15") email
            //-     | enviar
</template>
<script>
  import moment from 'moment'
  import { apiGet, notify } from '../util/general'
  export default {
    data () {
      return {
        type : 99,
        types: [
          {
            label: 'Enviados',
            value: 1
          },
          {
            label: 'Pendientes',
            value: 0
          },
          {
            label: 'Todos',
            value: 99
          }
        ],
        headerTable   : [
          {
            text : 'Id',
            align: 'start',
            value: 'id'
          },
          {
            text : 'Registro',
            align: 'start',
            value: 'fechaRegistro'
          },
          {
            text : 'Envio',
            align: 'start',
            value: 'fechaEnvio'
          },
          {
            text : 'Usuario',
            align: 'start',
            value: 'usuario'
          },
          {
            text : 'Asunto',
            align: 'start',
            value: 'asunto'
          },
          // {
          //   text : 'Contenido',
          //   align: 'start',
          //   value: 'contenido'
          // },
          {
            text : 'Plantilla',
            align: 'start',
            value: 'plantilla'
          },
          {
            text : 'Con copia',
            align: 'start',
            value: 'conCopia'
          },
          {
            text   : 'CC Oculta',
            align  : 'start',
            value  : 'conCopiaOculta'
          },
          {
            text : 'Enviado',
            align: 'start',
            value: 'enviado'
          },
          { text: 'To', value: 'data-table-expand' },
          {
            text : 'Accion',
            align: 'start',
            value: 'actions'
          }
        ],
        lista                 : [],
        disabledScrollExcecute: true,
        isScroll: true,
        noMore                : false,
        id                    : 0,
        isDialogEmail         : false,
        isLoadingHTML         : false,
        bodyHTML              : ''
      }
    },
    created () {
      var vm = this
      vm.getFetch()
    },
    computed : {
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      }
    },
    filters : {
      formatoFecha : function (val) {
        return moment(val).format('DD/MM/YYYY HH:mm')
      }
    },
    methods: {
      openDialog (id) {
        var vm = this
        vm.fetchHTML(id)
        vm.isDialogEmail = true
      },
      closeDialog () {
        var vm = this
        vm.isDialogEmail = false
        vm.bodyHTML = ''
      },
      getFetch () {
        var vm = this
        vm.id = 0
        vm.fetch()
      },
      fetchByScroll () {
        var vm = this
        vm.isScroll = true
        vm.fetch()
      },
      fetch () {
        var vm = this
        var url = 'mail/obtener'
        if (!vm.isScroll) {
          vm.lista = []
          vm.id = 0
        }
        vm.disabledScrollExcecute = true
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo emails' })
        vm.noMore                 = false
        var obj = {
          tipo: vm.type,
          id  : vm.id
        }
        apiGet(vm, url, obj, function (data) {
          for (var i = 0; i < data.lista.length; i++) {
            vm.lista.push(data.lista[i])
          }
          if (data.noMore) {
            vm.noMore = true
            vm.disabledScrollExcecute = true
          } else {
            vm.id = data.id
            vm.disabledScrollExcecute = false
          }
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
        }, function () {
          vm.isScroll  = false
          vm.$store.dispatch('transaccion', {isProceso : false})
        })
      },
      fetchHTML (id) {
        var vm = this
        vm.bodyHTML = false
        vm.isLoadingHTML = true
        var url = 'mail/obtener/html'
        vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo plantilla' })
        var obj = {
          id  : id
        }
        apiGet(vm, url, obj, function (data) {
          vm.bodyHTML = data.html
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
        }, function () {
          vm.isLoadingHTML = false
          vm.$store.dispatch('transaccion', {isProceso : false})
        })
      }
    }
  }
</script>
<style  lang="stylus">
.box-table
  height: calc(100vh - 197px);
  overflow-y: auto;
.box-table-movil
  height: calc(100vh - 276px);
  overflow-y: auto;
.return
  position absolute
  top 25px
  left 25px
  z-index: 10
.position-relative
  position relative
</style>



// WEBPACK FOOTER //
// View_notificaciones.vue?04525a33